import React, { useState } from 'react';

import { useList } from '../hooks/listHook';
import { useItem } from '../hooks/itemHook';
import EmptyList from '../useful/EmptyList';
import { withAuthorization } from '../session';
import TournamentListForm from './TournamentListForm';
import TournamentListItem from './TournamentListItem';
import TournamentLoader from '../loaders/TournamentLoader';
import ModalInfo from '../useful/ModalInfo';


const TournamentList = (props) => {

    const userId = props.firebase.auth.currentUser.uid;
    const { loading: loadingTournaments, list: tournaments } = useList(props.firebase.tournamentList(userId), userId);
    const { loading: loadingUser, item: userDb } = useItem(props.firebase.premiumUserDoc(userId), userId);
    const [modal, setModal] = useState({ show: false, title: '', message: '' });

    const loading = loadingTournaments && loadingUser;

    const showModal = (title, message) => {
        setModal({ show: true, title, message });
    }

    const loadingView = [1, 2, 3, 4].map((item) => {
        return (
            <div key={item} className="col-12 col-sm-6 col-md-4 col-lg-3 pr-1 pl-1 mb-2">
                <div className="col bg-light border border-white rounded-lg p-2 m-0">
                    <TournamentLoader />
                </div>
            </div>
        )
    });

    const listView = (tournaments && tournaments.length > 0) ?
        tournaments.map((item, i) => {
            return (
                <div key={item.uid} className="col-12 col-sm-6 col-md-4 col-lg-3 pr-1 pl-1 mb-2">
                    <TournamentListItem item={item} showModal={showModal} />
                </div>
            )
        })
        :
        <EmptyList />

    let countText = "";
    if (!loading && tournaments) {
        const actualCount = (tournaments.length || "0")
        const limitCount = (userDb && userDb.tournaments) || 0;
        countText = ": " + actualCount + "/" + limitCount;
    }


    let formComponent = <span className="nav justify-content-end small font-italic text-black-50">Ha alcanzado el máximo de torneos permitidos</span>
    if (userDb && ((userDb.tournaments || 0) > ((tournaments && tournaments.length) || 0))) {
        formComponent = <TournamentListForm showModal={showModal} countText={countText} />
    }



    return (
        <div>
            <div className="mb-3">
                {(!loading) ?
                    formComponent
                    :
                    <></>
                }
            </div>

            {/* <h6 className="font-weight-bolder">Listado de torneos{countText}</h6> */}

            {(!loading) ?
                <div className="row m-0">
                    {listView}
                </div>
                :
                <div className="row m-0">
                    {loadingView}
                </div>
            }

            <ModalInfo
                data={modal}
                onClose={() => setModal({ show: false, title: '', message: '' })}
            />

        </div>
    )
}

const condition = authUser => {
    if (!!authUser) {
        // return authUser.token.admin || authUser.token.premium;
        return authUser.token.premium;
    } else
        return false;
};
export default withAuthorization(condition)(TournamentList);